// @ts-nocheck
import clsx from "clsx";
import documents_treat from "includes/documents_treat";
import genRequest from "includes/request";
import DocIconDownloader from "Pages/Documents/components/DocIconDownloader/DocIconDownloader";
import { useQuery } from "react-query";
import "./DocumentsButtonBottomBar.css";

function DocumentsButton({ postId, toggleDocsExtend, documents, isMobile }) {
    const fetchDocs = () => {
        let req = genRequest("documents/post/" + postId + "/type/4")
            .then((resp) => documents_treat(resp, "publishedDate"));
        return (req);
    };

    const { isLoading, data } = useQuery(
        ["Documents", "DocumentOfPostAndType", postId, 4],
        fetchDocs,
        {
            enabled: (postId && !documents ? true : false)
        }
    );


    let count = documents ? documents?.length : data?.length;

    if ((!postId && !documents) || isLoading || (!isLoading && !count))
        return (false);

    return (
        <div className={clsx(isMobile ? "docMobile" : "d-flex border-left")}>
            {!isLoading && data.map(doc => (
                <>
                    {/* <FontAwesomeIcon icon={faFilePdf} className="me-2" /> */}
                    <DocIconDownloader key={doc.documentId} doc={doc} isMobile={isMobile} />

                </>
            ))}
            {/* <Button className="post-docs-btn btn-primary radius-3" onClick={toggleDocsExtend} title={t("Posts.DISPLAY_DOCS")}>
				<FontAwesomeIcon icon={faFilePdf} className="me-2" />
				{count} {t("Posts.DOCS_BTN", { count })}
			</Button> */}
        </div>
    );
}

export default DocumentsButton;